/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flow_Invitation_3Inputs */

const en_flow_invitation_3 = /** @type {(inputs: Flow_Invitation_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checked in at the showroom door.`)
};

/**
* | output |
* | --- |
* | "Checked in at the showroom door." |
*
* @param {Flow_Invitation_3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const flow_invitation_3 = /** @type {((inputs?: Flow_Invitation_3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flow_Invitation_3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_flow_invitation_3(inputs)
});